import React from 'react'
import { IconButton, Dialog, Box } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

interface ExpandImageDialogProps {
  open: boolean
  setExpandImage: (expandImage: boolean) => void
  imageUrl: any
  setShowImage?: (showImage: boolean) => void
  setImageUrl?: (img: any) => void
}

export const ExpandImageDialog = ({
  open,
  setExpandImage,
  imageUrl,
  setShowImage,
  setImageUrl
}: ExpandImageDialogProps) => {
  const handleClose = () => {
    setExpandImage(false)
    setShowImage && setShowImage(false)
    setImageUrl && setImageUrl(null)
  }
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="imagen-dialog-title"
      aria-describedby="imagen-dialog-description"
      PaperProps={{
        style: {
          display: 'flex',
          backgroundColor: 'transparent',
          boxShadow: 'none',
          maxWidth: '90%',
          maxHeight: '90%'
        }
      }}
    >
      <Box>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 3,
            top: 3,
            color: 'black',
            backgroundColor: 'white',
            fontSize: '10px'
          }}
        >
          <CloseIcon />
        </IconButton>
        <img
          src={imageUrl}
          alt="imagen"
          style={{
            objectFit: 'contain',
            maxWidth: '100%',
            maxHeight: '90vh'
          }}
        />
      </Box>
    </Dialog>
  )
}

export default ExpandImageDialog
